import { Box, Button, Flex, HStack, IconButton, Image } from "@chakra-ui/react";
import { useTranslation, withTranslation } from "react-i18next";
import { GiEarthAmerica } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import MobileNavbar from "../../public/Layout/mobileNavbar";

const Navbar = ({ color, register, t, type }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const routes = [
    { label: t("components.home_navbar.contact_us"), link: "#callCenter" },
    { label: t("components.home_navbar.subjects"), link: "#subjects" },
    { label: t("components.home_navbar.teachers"), link: "#teachers" },
    { label: t("components.home_navbar.home"), link: "/" },
  ];

  return (
    <Box
      position="fixed"
      zIndex="100"
      top="0"
      color={color}
      backdropBlur="lg"
      id="navbar"
      py="20px"
      bg="#e4e8ebd9"
      w="100%"
    >
      <HStack
        alignItems="center"
        p="5px"
        w="100%"
        justifyContent={"space-between"}
        textTransform={"capitalize"}
        h="50px"
      >
        <Flex
          display={{ base: "none", lg: "flex" }}
          visibility={register ? "visible" : "hidden"}
          flexDir="row"
          w="100%"
          gap={5}
          alignItems="center"
        >
          <Button
            onClick={() => navigate("/")}
            borderColor="main_2"
            bg="main_2"
            textTransform={"capitalize"}
            color="white"
          >
            {t("login")}{" "}
          </Button>

          <IconButton
            icon={<GiEarthAmerica />}
            borderColor="main_2"
            color="main_2"
            variant="outline"
            onClick={() => {
              const lang = localStorage.getItem("lang");

              if (lang === "ar") {
                localStorage.setItem("lang", "en");
                i18n.changeLanguage("en");
              } else {
                localStorage.setItem("lang", "ar");
                i18n.changeLanguage("ar");
              }
              // window.location.reload();
            }}
          />
          {routes?.map((elem, index) => {
            return (
              <a key={index} href={elem.link} style={{ color: "black" }}>
                {elem?.label}
              </a>
            );
          })}
        </Flex>

        <Box display={{ base: "block", lg: "none" }}>
          <MobileNavbar />
        </Box>
        <Box w="50px" h="50px">
          <Image
            src={require("../../../assets/logo.png")}
            w="200px"
            id="logo"
            h="auto"
            mx="-10px"
            onClick={() => navigate("/")}
          />
        </Box>
      </HStack>
    </Box>
  );
};

export default withTranslation()(Navbar);
